export const siteurl = document.getElementById('Siteurl').getAttribute('content')

export const endpoints = {
  wishlistTotal: `${siteurl}/shop/?qcAC=0&wishlist_marker=1`
}

export const breakpoints = {
  widepalm: '30em',
  lap: '45em',
  maxpalm: '44.999em',
  desk: '60em',
  max_site_width: '67.5em',
  wall: '125em',
}



// WEBPACK FOOTER //
// ./sportspower/assets/es6/config.js